import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { UIService } from '@core/services/ui.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressBar } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { LanguageService } from './core/services/language.service';

@Component({
  selector: 'app-root',
  imports: [RouterModule, RouterOutlet, ToastModule, AsyncPipe, ProgressBar, ConfirmDialogModule],
  template: `
    @if (isLoading$ | async) {
      <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
    }

    <router-outlet></router-outlet>
    <!-- p-toast component that will get triggered from ui service -->
    <p-toast class="print:hidden" key="top-center" position="top-center" />
    <p-confirmdialog styleClass="print:hidden" />
  `,
})
export class App implements OnInit {
  readonly languageService = inject(LanguageService);
  readonly UIService = inject(UIService);
  readonly isLoading$ = this.UIService.isLoading$;

  ngOnInit() {
    this.languageService.setupLanguages();
    this.UIService.initMode();
  }
}
